


















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const URL_PATTERN = /^https?:\/\/[^\s/$.?#][^\s]*$/i;

function emptyForm() {
  return {
    date: '',
    time: '',
    venue: '',
    address: '',
    memberSlug: null,
    url: '',
    note: '',
    active: true,
  };
}

@Component({
  props: {
    active: Boolean,
    event: Object,
  },
})
export default class DlgEventEdit extends Vue {
  public $refs!: {
    form: any,
  };

  private dialog: boolean = false;
  private valid: boolean = true;
  private loading: boolean = false;
  private dateMenu: boolean = false;
  private membersLoading: boolean = false;
  private form: any = emptyForm();

  @Action('events/create') private eventCreate!: any;
  @Action('events/update') private eventUpdate!: any;
  @Action('events/read') private eventGetAll!: any;
  @Action('members/read') private readMembers!: any;
  @Getter('members/all') private members!: any[];
  @Getter('rules/all') private rules!: any;

  get isNew() {
    return !(this.$props.event && this.$props.event.id);
  }

  get dateFormatted() {
    if (!this.form.date) {
      return '';
    }
    const [year, month, day] = this.form.date.split('-');
    return `${day}.${month}.${year}`;
  }

  get memberItems() {
    const items = (this.members || [])
      .filter((member: any) => member.slug)
      .map((member: any) => ({ title: member.title || member.slug, slug: member.slug }))
      .sort((a: any, b: any) => a.title.localeCompare(b.title, 'de'));
    // keep a slug that no longer matches a member visible instead of silently dropping it
    if (this.form.memberSlug && !items.some((item: any) => item.slug === this.form.memberSlug)) {
      items.unshift({ title: `${this.form.memberSlug} (Mitglied nicht gefunden)`, slug: this.form.memberSlug });
    }
    return items;
  }

  private timeRule(value: string) {
    return !value || TIME_PATTERN.test(this.normalizeTime(value)) || 'Bitte im Format HH:MM angeben, z. B. 18:30';
  }

  private urlRule(value: string) {
    return !value || !value.trim() || URL_PATTERN.test(value.trim())
      || 'Bitte eine gültige Adresse mit http:// oder https:// angeben';
  }

  private maxLength(length: number) {
    return (value: string) => !value || value.length <= length || `Höchstens ${length} Zeichen`;
  }

  /**
   * Accepts '18.30', '9:00' or '1830' and turns them into 'HH:MM'.
   */
  private normalizeTime(value: string) {
    if (!value) {
      return value;
    }
    let time = value.trim().replace(/[.,h]/g, ':');
    if (/^\d{3,4}$/.test(time)) {
      time = `${time.slice(0, -2)}:${time.slice(-2)}`;
    }
    if (/^\d:\d{2}$/.test(time)) {
      time = `0${time}`;
    }
    return time;
  }

  @Watch('active')
  private async onActiveChanged(newVal: boolean) {
    this.dialog = newVal;

    if (newVal) {
      const event = this.$props.event || {};
      this.form = {
        ...emptyForm(),
        ...JSON.parse(JSON.stringify(event)),
      };
      if (typeof this.form.active !== 'boolean') {
        this.form.active = true;
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (!this.members || !this.members.length) {
        this.membersLoading = true;
        await this.readMembers();
        this.membersLoading = false;
      }
    }
  }

  private async save() {
    this.form.time = this.normalizeTime(this.form.time);

    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      date: this.form.date,
      time: this.form.time,
      venue: (this.form.venue || '').trim(),
      address: (this.form.address || '').trim(),
      memberSlug: this.form.memberSlug || '',
      url: (this.form.url || '').trim(),
      note: (this.form.note || '').trim(),
      active: this.form.active !== false,
    };

    this.loading = true;
    const success = this.isNew
      ? await this.eventCreate(data)
      : await this.eventUpdate({ id: this.$props.event.id, data });
    this.loading = false;

    if (success) {
      this.close();
      await this.eventGetAll();
    }
  }

  private close() {
    this.dialog = false;
    this.$emit('close');
  }
}
